import { SectionSideContentWithMediaProps } from '@portfolio/models'
import { SectionWrapper, Media, PortableText } from '@portfolio/components'
import { styled } from '@portfolio/styles'

const SectionSideContentContainer = styled('div', {
  '@lg': {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 64,
    paddingInline: 32,
  },
})

const SectionSideContentTitle = styled('h2', {
  marginBottom: 56,
  projectFont: 'heading04',
  color: '$white',
  paddingInline: 32,

  '@lg': {
    paddingInline: 0,
    marginBottom: 0,
  },
})

const ContentList = styled('div', {
  display: 'grid',
  gridAutoFlow: 'column',
  gap: '$20',
  gridAutoColumns: '75vw',
  paddingInline: 32,
  scrollPaddingInline: 32,
  overflowX: 'auto',
  overflowY: 'hidden',
  scrollSnapType: 'x mandatory',

  '&::-webkit-scrollbar': {
    display: 'none',
  },

  '@lg': {
    display: 'flex',
    flexDirection: 'column',
    gap: 72,
    width: 'auto',
    overflow: 'visible',
    scrollSnapType: 'none',
    paddingInline: 0,
    scrollPaddingInline: 0,
  },
})

const ContentItem = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  scrollSnapAlign: 'start',

  '@lg': {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
})

const MediaContainerMobile = styled('div', {
  borderRadius: 6,
  overflow: 'hidden',
  width: '100%',

  '@lg': {
    display: 'none',
  },
})

const MediaContainerDesktop = styled('div', {
  borderRadius: 6,
  overflow: 'hidden',
  width: '100%',
  maxWidth: 120,
  display: 'none',

  '@lg': {
    display: 'block',
  },
})

const ContentWrapper = styled('div', {
  width: '100%',
})

const CustomPortableTextWrapper = styled('div', {
  fontFamily: 'var(--font-suisse-intl-regular), sans-serif',
  fontWeight: 400,
  fontSize: 20,
  lineHeight: '130%',
  color: '$white',
})

export function SectionSideContentWithMedia({
  title,
  content,
  spacing,
  topBorder,
}: SectionSideContentWithMediaProps) {
  return (
    <SectionWrapper type={spacing || 'DEFAULT'} topBorder={topBorder}>
      <SectionSideContentContainer>
        {title && <SectionSideContentTitle>{title}</SectionSideContentTitle>}
        {content && content.length > 0 && (
          <ContentList>
            {content.map((item, index) => {
              const itemKey =
                '_key' in item && typeof item._key === 'string'
                  ? item._key
                  : `item-${index}`
              return (
                <ContentItem key={itemKey}>
                  {item.media?.mediaPayload && (
                    <>
                      <MediaContainerDesktop>
                        <Media
                          {...item.media}
                          layout="responsive"
                          hardcropRatio="square"
                          sizes="(max-width: 768px) 75vw, 120px"
                        />
                      </MediaContainerDesktop>
                      <MediaContainerMobile>
                        <Media
                          {...item.media}
                          layout="responsive"
                          hardcropRatio="landscape4"
                          sizes="(max-width: 768px) 75vw, 120px"
                        />
                      </MediaContainerMobile>
                    </>
                  )}
                  {item.localeEditorialRichText && (
                    <ContentWrapper>
                      <CustomPortableTextWrapper>
                        <PortableText
                          value={item.localeEditorialRichText}
                          appearance="plain"
                          disableTopBottomMargins={true}
                        />
                      </CustomPortableTextWrapper>
                    </ContentWrapper>
                  )}
                </ContentItem>
              )
            })}
          </ContentList>
        )}
      </SectionSideContentContainer>
    </SectionWrapper>
  )
}
